import { createStyles, Table, Text, Paper } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.colors.gray[2]}`,
    overflow: "hidden",
  },
  label: {
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.sm,
    width: "35%",
  },
  value: {
    color: theme.colors.gray[8],
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,
  },
  heading: {
    fontSize: theme.fontSizes.sm,
    fontWeight: 600,
    color: theme.colors.gray[8],
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    marginBottom: theme.spacing.sm,
  },
}));

export default function ProductSpecs({ specs, title = "產品規格" }) {
  const { classes } = useStyles();
  if (!specs?.length) return null;

  return (
    <div>
      <Text className={classes.heading}>{title}</Text>
      <Paper className={classes.paper} radius="md" shadow="xs" p={0}>
        <Table verticalSpacing="sm" horizontalSpacing="md" striped highlightOnHover>
          <tbody>
            {specs.map((row) => (
              <tr key={row.label}>
                <td className={classes.label}>{row.label}</td>
                <td className={classes.value}>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Paper>
    </div>
  );
}
